<template>
	<div class="container pt-6 pb-10">
		<div class="flex justify-between items-center py-2 mb-4">
			<h1 class="page-title">Oferte către {{ clientName ? clientName : 'client' }}</h1>
		</div>

		<v-data-table :headers="headers" :items="salesOffers" :loading="loadingSalesOffers" :items-per-page="-1"
			hide-default-footer>
			<template v-slot:item.status="{ item }">
				<OfertaStatus :item="item" @changeStatus="changeStatus" />
			</template>
			<template v-slot:item.data="{ item }">
				{{ item.data | formatDate }}
			</template>
			<template v-slot:item.suma="{ item }">
				{{ item.suma }} {{ item.moneda }}
			</template>
			<template v-slot:item.actions="{ item }">
				<v-btn text rounded color="primary" :to="'/oferte/single/' + item.id">detalii</v-btn>
			</template>
		</v-data-table>

		<v-dialog v-model="visibleStatusModal" max-width="600px">
			<OfertaStatusCard :changedStatusItem="changedStatusItem" :sentAnalysis="sentAnalysis"
				@requestAnalysis="visibleAnalysisDialog = true" @close="closeModal" />
		</v-dialog>

		<v-dialog v-model="visibleAnalysisDialog" max-width="700px">
			<v-card>
				<v-form ref="analysisForm" v-model="validAnalysisForm" @submit.prevent="sendAnalysisReq">
					<v-card-title>
						<span class="text-h5">Solicită analiza clientului</span>
					</v-card-title>
					<v-card-text v-if="changedStatusItem.client">
						<div>
							<h3 class="mb-4"><span class="font-normal">Client: </span>{{ changedStatusItem.client.name
							}} {{ changedStatusItem.client.cui ? '(' + changedStatusItem.client.cui + ')' : '' }}
							</h3>
							<p>Completeză următoarele informații despre client</p>
						</div>
						<div class="grid grid-cols-2 gap-x-4">
							<v-select label="Cifră afaceri an precendent" outlined v-model="analysisLead.turnover"
								:items="turnoverOptions" item-text="text" item-value="value" suffix="RON"
								:rules="[rules.required]"></v-select>
							<v-select label="Profit net an precedent" outlined v-model="analysisLead.netProfit"
								:items="profitOptions" item-text="text" item-value="value" suffix="RON"
								:rules="[rules.required]"></v-select>
							<v-select label="Domeniu de activitate" outlined v-model="analysisLead.activityField"
								:items="activityFields" item-text="text" item-value="value"
								:rules="[rules.required]"></v-select>
							<v-select label="Nr. angajati" outlined v-model="analysisLead.employees"
								:items="employeeOptions" item-text="text" item-value="value" suffix="angajati"
								:rules="[rules.required]"></v-select>
						</div>
					</v-card-text>
					<div class="flex flex-row justify-end gap-2 mt-4 p-4">
						<v-btn color="blue-grey" class="uppercase" dark large
							@click="closeAnalysisModal">Anuleaza</v-btn>
						<v-btn color="teal" dark class="uppercase" large type="submit">Trimite</v-btn>
					</div>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- <pre>{{ salesOffers }}</pre> -->
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { DateTime } from 'luxon';
import OfertaStatus from './OfertaStatus.vue';
import OfertaStatusCard from './OfertaStatusCard.vue';

export default {
	name: "OferteClient",
	components: {
		OfertaStatus,
		OfertaStatusCard
	},
	data() {
		return {
			validAnalysisForm: false,
			filterInput: "",
			visibleStatusModal: false,
			visibleAnalysisDialog: false,
			headers: [
				{
					text: 'Nr.',
					align: 'start',
					sortable: false,
					value: 'id'
				},
				{
					text: 'Data',
					align: 'start',
					sortable: false,
					value: 'data',
				},
				{
					text: 'Status',
					align: 'center',
					sortable: false,
					value: 'status',
					width: '5%'
				},
				{
					text: 'Client',
					align: 'start',
					sortable: false,
					value: 'nume',
				},
				{
					text: 'Valoare',
					align: 'start',
					sortable: false,
					value: 'suma',
				},
				{
					text: 'Intocmit de',
					align: 'start',
					sortable: false,
					value: 'username',
				},
				{
					value: 'actions',
					sortable: false,
					width: '5%'
				}
			],
			changedStatusItem: {},
			sentAnalysis: false,
			analysisLead: {},
			rules: {
				required: value => !!value || 'Câmp obligatoriu'
			}
		};
	},
	computed: {
		...mapState('salesOffers', ["salesOffers", "loadingSalesOffers"]),
		...mapState('salesLeads', ['turnoverOptions', 'profitOptions', 'activityFields', 'employeeOptions']),
		clientName() {
			return this.salesOffers.length ? this.salesOffers[0].nume : '';
		},
		user() {
			return this.$store.getters.loggedUser;
		}
	},
	watch: {},
	methods: {
		...mapActions('salesOffers', [
			"fetchSalesClientOffers",
			"sendAnalysisRequest"
		]),
		changeStatus(item) {
			this.changedStatusItem = Object.assign({}, { id: item.id, client: { name: item.nume, cui: item.cui }, status_oferta: item.status_oferta, contactDate: item.contact_date || DateTime.now().toFormat('yyyy-LL-dd'), contactType: item.contact_type, pending_reason: item.pending_reason, reject_reason: item.reject_reason })
			this.visibleStatusModal = true
		},
		closeModal() {
			this.visibleStatusModal = false
			this.$nextTick(() => {
				this.changedStatusItem = Object.assign({}, {})
				this.sentAnalysis = false
				this.analysisLead = Object.assign({}, {})
			})
		},
		closeAnalysisModal() {
			this.visibleAnalysisDialog = false
			this.$nextTick(() => {
				this.analysisLead = Object.assign({}, {})
			})
		},
		async sendAnalysisReq() {
			const valid = await this.$refs.analysisForm.validate();

			if (valid) {
				this.sendAnalysisRequest({ leadData: this.analysisLead, client: this.changedStatusItem.client, user: { name: this.user.username, email: this.user.email_user } });
				this.sentAnalysis = true
				this.visibleAnalysisDialog = false
			}
		},
		async changeOfertaStatus() {
			const valid = await this.$refs.statusForm.validate();

			if (valid) {
				this.$store.dispatch("updOfertaStatus", this.changedStatusItem);
				this.closeModal()
			}
		},
	},
	created: function () {
		this.fetchSalesClientOffers(this.$route.params.id);
	},
	destroyed() {
		this.$store.commit('salesOffers/loadSalesOffers', [])
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
